import { exists } from '../helpers';
import {
  convertRelumeToFinsweetVariables,
  inlineRelumeAndFinsweetVariables,
} from './convert_variables';
import finsweetComponentStylesV21Raw from './finsweet_component_stylesv2.1.json';
import finsweetComponentStylesV2Raw from './finsweet_component_stylesv2.json';
import { Component, SiteStyle } from './schema';

/** Convert a component that uses the Relume style guide to use the Finsweet style guide. */
export function convertToFinsweet(component: Component, version: '2' | '2.1') {
  const finsweetStyles = new Map<string, SiteStyle>();
  let rawStyles = finsweetComponentStylesV21Raw;
  if (version === '2') {
    rawStyles = finsweetComponentStylesV2Raw as any;
  }
  for (const raw of rawStyles) {
    const style = raw as any;
    finsweetStyles.set(style.data.name, style);
  }

  let componentText = JSON.stringify(component);
  for (const [from, to] of STRING_REPLACEMENTS) {
    componentText = componentText.replaceAll(from, to);
  }
  component = JSON.parse(componentText);
  if (version === '2') {
    // version 2 has no variables
    component = inlineRelumeAndFinsweetVariables(component);
  }

  const newStyles = component.payload.styles
    .map((style) => {
      const { name } = style;
      if (
        (name.includes('padding') || name.includes('margin')) &&
        name !== 'margin-top' &&
        name !== 'page-padding' &&
        name !== 'padding-global' &&
        !name.includes('padding-section')
      ) {
        // there's a quirk with how the relume library is represented in json
        // this seems to fix the issue but I'm not 100% sure why.
        // I suspect some clever inheritance is going on.
        return style;
      }
      const finsweetStyle = finsweetStyles.get(name);
      if (finsweetStyle) {
        const tmp = { ...style };
        if (finsweetStyle.data.styleLess) {
          tmp.styleLess = finsweetStyle.data.styleLess;
        }
        if (finsweetStyle.data.variants) {
          tmp.variants = finsweetStyle.data.variants as any;
        }
        return tmp;
      }
      return style;
    })
    .filter(exists);
  const newComponent = {
    ...component,
    payload: { ...component.payload, styles: newStyles },
  };
  if (version === '2') {
    return newComponent;
  }
  return convertRelumeToFinsweetVariables(newComponent);
}

const STRING_REPLACEMENTS: [string, string][] = [
  /* Swatches */
  ['@swatch_150a737e', 'hsla(0, 0.00%, 95.69%, 1.00)'],
  ['@swatch_dccb7db6', 'hsla(0, 0.00%, 0.00%, 1.00)'],
  ['@swatch_1766b841', 'hsla(0, 0.00%, 100.00%, 1.00)'],
  /* Class names */
  ['form-block', 'form_component'],
  ['form-input', 'form_input'],
  ['form-field-wrapper', 'form_field-wrapper'],
  ['field-label', 'form_label'],
  ['form-input', 'form_input'],
  ['form-checkbox', 'form_checkbox'],
  ['form-checkbox-icon', 'form_checkbox-icon'],
  ['form-checkbox-label', 'form_checkbox-label'],
  ['form-radio', 'form_radio'],
  ['form-radio-icon', 'form_radio-icon'],
  ['form-radio-label', 'form_radio-label'],
];
